<template>
  <div class="page-container" style="min-height: 800px;">
    <div class="page-title-container">
      <h1 class="title-text">Reset your password</h1>
    </div>

    <div class="features-container">
      <div class="box" style="text-align: center;">
        <p v-if="showEmail">We will send you an email to recover your account. Check your inbox (and your spam). Thank you!</p>
        <div class="cta-container">
          <input
            class="input-container input-conatiner-medium"
            placeholder="Enter your email"
            ref="email"
            v-if="showEmail"
            v-model="email"
            @click="selectEmail"
            type="text"
            @keyup.enter="recover"
          />
          <button class="primary-button" v-if="showEmail" @click="recover">Send email</button>
        </div>

        <p style="text-align: center;" v-if="showOk">
          If the mail was registered in our platform you will receive an email, check the spam box too. Thank you!
        </p>
        <button class="primary-button medium-button" v-if="showOk" @click="returnToHome">Return to Log in</button>

        <p class="p-error" v-if="showEmailBadFormat">Email format required. Example: name@domain.com</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as validator from "email-validator";
import router from "@/router";
import firebase from "@/firebase";
import utils from "@/utils";

export default {
  created() {
    window.scrollTo(0, 0);
  },

  data: function() {
    return {
      email: "",
      showEmail: true,
      showOk: false,
      showEmailBadFormat: false,
    };
  },

  mounted: function() {
    this.focusEmail();
  },

  methods: {
    returnToHome() {
      router.push({ path: "login" });
    },

    focusEmail() {
      this.$refs.email.focus();
    },

    selectEmail(event) {
      event.target.setSelectionRange(0, this.email.length);
    },

    recover() {
      this.showEmailBadFormat = false;
      if (!validator.validate(this.email)) {
        this.showEmailBadFormat = true;
        this.focusEmail();
        return;
      }

      firebase.auth
        .sendPasswordResetEmail(this.email)
        .then(() => {
          this.showEmail = false;
          this.showOk = true;
        })
        .catch((error) => {
          if (utils.isDev) {
            console.error(error);
          }

          this.showEmail = false;
          this.showOk = true;
        });
    },
  },
};
</script>

<style scoped></style>
